<template>
  <el-dialog title="分类维护" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height">

          <el-button @click="insertEvent" status="primary" class="button-sty btn3" icon="el-icon-plus">新增</el-button>

          <!-- <div class="fr">
            <el-button type="warning" class="button-sty" icon="el-icon-search" @click="searchEvent">搜索</el-button>
          </div> -->


          <!-- <div class="input_main">
            <div class="main">
              <el-form class="screen-box" title-width="92px" title-align="right" :data="formData"
                       @submit="searchEvent" @reset="searchEvent">
                <div class="main_item">
                  <el-form-item>
                    <div class="item_items">
                      <span>名称:</span>
                      <el-input v-model="title" placeholder=""></el-input>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div> -->
          <vxe-table
            :header-cell-style="{height: '36px',   padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
            :row-config="{height: 36,padding: 0,isHover: true,}"
            :row-style="{ fontSize: '12px',  }"
            :stripe="true"
            resizable
            show-overflow
            keep-source
            ref="xTable"
            row-id="id"
            :edit-rules="validRules"
            :print-config="{}"
            :export-config="{}"
            :loading="loading"
            :tree-config="{transform: true, rowField: 'id', parentField: 'parentId'}"
            :edit-config="{trigger: 'manua', mode: 'row', showStatus: true, autoClear: false}"
            :data="tableData"
          >
            <vxe-column type="checkbox" width="100" tree-node></vxe-column>
            <vxe-column field="typeName" title="名称" :edit-render="{}">
              <template #edit="scope">
                <vxe-input v-model="scope.row.typeName" @blur="validEvent" @change="$refs.xTable.updateStatus(scope)"
                           type="text"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column field="seq" title="排序" :edit-render="{}">
              <template #edit="scope">
                <vxe-input v-model="scope.row.seq" type="integer" min="0" max="10" clearable></vxe-input>
              </template>
            </vxe-column>
            <vxe-column field="usable" title="状态"
                        :edit-render="{name: 'select', options:[{ value:1, label:'启用' }, { value:0, label:'禁用' }]}">
              <template #edit="scope">
                <vxe-select v-model="scope.row.usable">
                  <vxe-option :value="1" label="启用">启用</vxe-option>
                  <vxe-option :value="0" label="禁用">禁用</vxe-option>
                </vxe-select>
              </template>
            </vxe-column>

            <vxe-column title="操作" width="500">
              <template #default="{ row }">
                <vxe-button v-if="row.parentId==0" type="text" status="primary" @click="insertRow(row, 'top')"><i
                  class="el-icon-circle-plus-outline"></i></vxe-button>
                <vxe-button v-if="$refs.xTable.isActiveByRow(row)" type="text" status="primary" @click="addRow(row)"><i
                  class="el-icon-circle-check"> </i></vxe-button>
                <vxe-button v-if="$refs.xTable.isActiveByRow(row)&&!row.isNew" type="text" status="primary"
                            @click="closeEdit(row)"><i class="el-icon-circle-close"></i></vxe-button>
                <vxe-button v-if="$refs.xTable.isActiveByRow(row)&&row.isNew" type="text" status="primary"
                            @click="removeRow(row)"><i class="el-icon-circle-close"></i></vxe-button>
                <vxe-button v-if="!$refs.xTable.isActiveByRow(row)" type="text" status="primary"
                            @click="updateRowEvent(row)"><i class="el-icon-edit"></i></vxe-button>
              </template>
            </vxe-column>
          </vxe-table>

        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
      <!--			<el-button type="primary" plain class="button-sty" @click="dialogClose">-->
      <!--				<i class="el-icon-close el-icon"></i>-->
      <!--				取 消-->
      <!--			</el-button>-->
      <!--			<el-button type="primary" @click="dialogClose" class="button-sty">-->
      <!--				<i class="el-icon-check el-icon"></i>-->
      <!--				确 定-->
      <!--			</el-button>-->
		</span>
  </el-dialog>
</template>

<script>
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'

import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import api from "@/api/projectApi";
import {mapGetters} from 'vuex';

export default {
  name: '',
  components: {pager},

  created() {
    this.orderdataId = this.orderId ? this.orderId : ""
    this.initTableList();
  },


  data() {
    return {
      total: 0,
      filterText: '',
      orderdataId: "",
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {},
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchItemName: '',
      searchItemCode: '',
      searchBrandName: '',
      selectedRow: {
        id: '', name: ''
      },
      flag: false,  // 插入标识，确保一次只能插入一条数据
      loading: false,
      tableData: [],
      validRules: {
        typeName: [
          {required: true, message: '名称不能为空'},
          {min: 1, max: 20, message: '名称长度在 1 到 20 个字符'}
        ],
        seq: [
          {required: true, message: '排序不能为空'},
        ]
      },
      title: null,


    };
  },
  mounted() {
    this.findList();
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.initTableList()
      }
    }
  },
  computed: {
    ...mapGetters(["permissions"])
  },


  methods: {
    dialogClose() {

      this.showDialog = false
      this.$emit('commitOrgSelect')

    },
    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },


    cellClickEvent(e) {
      console.log(e.row.id, '单元格点击事件')
    },


    radioChangeEvent({row}) {
      this.selectedRow = {
        id: row.id,
        name: row.name,
        code: row.orgCode,
        orgIdPath: row.orgIdPath,
        orderId: this.orderdataId
      }
    },


    commitRow() {
      this.$mask.open()


      this.dialogClose()
      this.$mask.close()

    },


    // // 搜索
    // searchEvent() {
    //   this.$refs['table-m1'].commitProxy('reload');
    // },

    // 重置
    resetEvent() {
      this.formData.name = ''
    },

    // 关闭编辑状态
    closeEdit(row) {
      const $grid = this.$refs.xTable
      $grid.clearActived().then(() => {
        this.$http({
          url: api.sfFeeType.getData,
          method: 'post',
          data: {id: row.id}
        }).then(res => {
          let data = res.data.data;
          row.typeName = data.typeName
          row.seq = data.seq
          row.usable = data.usable
          this.flag = false
        })
      })
    },

    // 开启编辑
    updateRowEvent(row) {
      console.log(row, '开启编辑')
      const $grid = this.$refs.xTable
      $grid.setActiveRow(row)
      this.flag = true
    },

    // 更新到后端
    async removeRow(row) {
      const $table = this.$refs.xTable
      await $table.remove(row)
      this.flag = false
    },

    // 添加到后端
    async addRow(row) {
      const $table = this.$refs.xTable
      const errMap = await $table.validate().catch(errMap => errMap)
      if (errMap) {
        VXETable.modal.message({status: 'error', content: '校验不通过！保存失败'})
      } else {
        this.$http({
          url: row.isNew ? api.sfFeeType.add : api.sfFeeType.update,
          method: 'post',
          data: row
        }).then(res => {
          row.id = res.data.data
          row.isNew = false
          const $grid = this.$refs.xTable
          $grid.clearActived().then(() => {
            VXETable.modal.message({status: 'success', content: '保存成功'})
            this.flag = false
            this.reload()  // 存在显示bug，新增显示缩进消失，只能刷新
          })
        }).catch(e => {
          VXETable.modal.message({status: 'error', content: '保存失败'})
          console.error(e)
        })

      }
    },


    findList() {
      this.loading = true
      return new Promise(resolve => {
        this.$http({
          url: api.sfFeeType.getList,
          data: {title: this.title},
          method: 'post'
        }).then(res => {
          this.tableData = res.data.data
          this.loading = false
          resolve()
        })

      })
    },

    // 顶级类型新增
    insertEvent() {
      if (this.flag) {
        this.$message.warning('请先完成当前正在进行的编辑或新增操作')
        return
      }
      const $table = this.$refs.xTable
      if (!this.flag) {
        const newRow = {
          id: 0,
          parentId: 0,
          seq: 0,
          usable: 1,
          isNew: true
        }
        $table.insert(newRow).then(({row}) => $table.setActiveRow(row))
      }
      this.flag = true
    },

    // 表格插入
    async insertRow(currRow, locat) {
      if (this.flag) {
        this.$message.warning('请先完成当前正在进行的编辑或新增操作')
        return
      }
      const $table = this.$refs.xTable
      // 如果 null 则插入到目标节点顶部
      // 如果 -1 则插入到目标节点底部
      // 如果 row 则有插入到效的目标节点该行的位置
      if (locat === 'top') {
        const record = {
          name: '新数据',
          id: Date.now(),
          parentId: currRow.id, // 需要指定父节点，自动插入该节点中
          usable: 1,
          isNew: true,
          seq: 0
        }
        const {row: newRow} = await $table.insert(record)
        await $table.setTreeExpand(currRow, true) // 将父节点展开
        await $table.setActiveRow(newRow) // 插入子节点
        this.flag = true
      }
    },


    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },


    // 搜索
    searchEvent() {
      this.findList()
    },

    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
    initTableList() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: '/basic/basRecallProject/getListPage',
        param: this.formData,
        method: 'post',
        height: '800px',
        columns: [
          {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
          {
            title: '分类名称',
            field: 'projectName',
            width: 150,
            fixed: 'left'
          },
          {
            title: '上级分类',
            field: 'projectCode',
            width: 150,
          },
          {
            title: '启用',
            field: 'usable',
            width: 150,
            slots: {
              default: ({row}) => {
                if (row.usable == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>禁用</span>
                    </div>
                  ];
                } else if (row.usable == 1) {
                  return [
                    <div class="txt-status">
                      <span>启用</span>
                    </div>
                  ];
                }
              }
            }
          },
          {
            field: 'createTime',
            title: '创建时间',
            width: 150
          },
          {
            title: '创建人',
            field: 'createBy',
            width: 150,

          },
          {
            width: 47,
            fixed: 'right',
            title: '',
            sortable: false,
            slots: {
              default: ({row}) => {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        ]
      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  // width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -53px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

::v-deep .vxe-loading {
  background-color: rgba(255, 255, 255, .2) !important
}

.btn3 {
  color: #fff;
  background-color: #00e3cf;
  border-color: #00e3cf;
  margin: 5px;
}
</style>
